import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DisclaimerModule } from '@core/components/disclaimer/disclaimer.module';
import { EquipmentsTypeSelectModule } from '@core/components/inputs/equipments-type-select/equipments-type-select.module';
import { EquipmentsTypeComponentModule } from '@core/components/inputs/equipments-type/equipments-type.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { TabEquipmentsComponent } from './tab-equipments.component';

@NgModule({
  declarations: [
    TabEquipmentsComponent
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    DisclaimerModule,
    MatTooltipModule,
    LocationsComponentModule,
    EquipmentsTypeSelectModule,
    EquipmentsTypeComponentModule
  ],
  exports: [
    TabEquipmentsComponent
  ]
})
export class TabEquipmentsModule { }
